import axiosInstance from "@/services/axiosInterceptor";

export async function getUniversityByCountryAndRegion(countryCode, region) {
  try {
    const response = await axiosInstance.get(
      `common/universities?countryCode=${countryCode}&regionIds=${region}`
    );
    const data = response?.data.rows;
    return data;
  } catch (error) {
    throw error;
  }
}
